import styled from 'styled-components'

export const ExpensesContainer = styled.div`
  margin: 10px 50px;
  display: flex;
  height: 100%;
`
